import styled from "styled-components";

export const Container = styled.section`
    width: 100%;
`
export const List = styled.ul`
    max-width: 1140px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    padding: 30px 0 45px;
`
export const Text = styled.p`
    font-size: 17px;
    color: #777777;
    line-height: 1.66em;
`

